<template>
  <p class="crowded_txt"><fa-icon icon="ban" /><span>現在満員となっております</span></p>
</template>

<script>
export default {
  name: "Crowded"
}
</script>
